import Vue from "vue";
import Vuex from "vuex";
import {
  addJobDesc,
  getJobDesc,
  putJobDesc,
  deleteJobDesc,
  getTopic,
} from "../../utils/apiFunctions.js";
Vue.use(Vuex);

// State
const state = () => ({
  customerDetail: {},
  jobData: {},
  sourceSelect: "",
  LoadStatus: false,
  singleJdDetails: {},
  topicsDetails: [],
  jobDescDetails: [],
  assesmentData: [],
  savedInterview: {},
  savedFeedBack: {},
  selectedCandidate: {},
  selectedProcess: {},
});

// getters
const getters = {
  getSavedInterview: (state) => state.savedInterview,
  getSavedFeedBack: (state) => state.savedFeedBack,
  getAssesmentData: (state) => state.assesmentData,
  getJobData: (state) => state.jobData,
  getCustomerDetail: (state) => state.customerDetail,
  getSelectedCandidate: (state) => state.selectedCandidate,
  getSelectedProcess: (state) => state.selectedProcess,
  getsaveAllJobDesc: (state) => {
    const sort = state.sourceSelect;

    let finalTopicDetails = [];

    // Alpha Sorting
    if (sort === "1") {
      finalTopicDetails = state.jobDescDetails
        .slice()
        .sort((a, b) => a.title.localeCompare(b.title));
    }
    // Reverse Alpha Sorting
    else if (sort === "2") {
      finalTopicDetails = state.jobDescDetails
        .slice()
        .sort((a, b) => a.title.localeCompare(b.title))
        .slice()
        .reverse();
    }
    // Date Sort
    else if (sort === "3") {
      finalTopicDetails = state.jobDescDetails.slice().reverse();
    } else {
      finalTopicDetails = state.jobDescDetails;
    }
    return finalTopicDetails;
  },
  getSingleJdDetails: (state) => state.singleJdDetails,
  getLoadStatus: (state) => state.LoadStatus,
  getTopicsDetails: (state) => state.topicsDetails,
};

// actions
const actions = {
  // POST JOB DESC API
  async saveJobDescription(state, payload) {
    try {
      const data = await payload;
      const response = await addJobDesc(data);
      if (response.status == 200) {
        state.commit("saveJobDesc", data);
      }
      return response;
    } catch (error) {
      return error;
    }
  },

  // GET JOB DESC API
  async getJobDesc(state, payload) {
    try {
      const res = await getJobDesc(payload);
      if (res.status == 200) {
        let payload = res.data.data;
        state.commit("saveAllJobDesc", payload);
      }
      return res;
    } catch (error) {
      throw new Error(`Failed! status:${error.status}`);
    }
  },
  //get topic
  async getTopic(state) {
    getTopic()
      .then((res) => {
        if (res.status == 200) {
          let payload = res.data.data.topicIDs;
          state.commit("saveTopics", payload);
        }
      })
      .catch((err) => {
        throw err;
      });
  },

  // PUT JOB DESC API
  async editJobDesc(state, payload) {
    try {
      const data = await payload;
      const response = await putJobDesc(data);
      if (response.status == 200) {
        state.commit("editCurrentJobDesc", data);
      }
      return response;
    } catch (error) {
      return error;
    }
  },

  // DELETE JOB DESC API
  async deleteJobDesc({ commit }, payload) {
    try {
      const response = await deleteJobDesc(payload);
      if (response.status == 200) {
        commit("deleteCurrentJD", payload);
      }
      return response;
    } catch (error) {
      throw new Error(`Delete Job Failed! status: ${error.status}`);
    }
  },
};

// mutations
const mutations = {
  saveAssesmentData(state, payload) {
    state.assesmentData = payload;
  },
  saveInterviewObject(state, payload) {
    state.savedInterview = payload;
  },
  saveFeedBackObject(state, payload) {
    state.savedFeedBack = payload;
  },
  saveJobData(state, payload) {
    state.jobData = payload;
  },
  saveCustomerDetail(state, payload) {
    Vue.set(state, "customerDetail", payload);
  },
  // add JOB DESC
  saveJobDesc(state, payload) {
    state.jobDescDetails.push(payload);
  },
  saveLoadStatus(state, payload) {
    state.LoadStatus = payload;
  },
  saveAllJobDesc(state, payload) {
    state.jobDescDetails = payload;
  },
  saveTopics(state, payload) {
    state.topicsDetails = payload;
  },

  // EDIT JOB DESC
  editCurrentJobDesc(state, payload) {
    for (let i in state.jobDescDetails) {
      if (state.jobDescDetails[i].jobID === payload.jobID) {
        // Copying the OBJECT
        state.jobDescDetails[i] = { ...payload };
      }
    }
  },

  saveSingleJdDetails(state, payload) {
    state.singleJdDetails = { ...payload };
  },

  // DELETE JD
  deleteCurrentJD(state, payload) {
    state.jobDescDetails = state.jobDescDetails.filter(
      (data) => data.jobID != payload.jobID
    );
  },
  // sort commit
  sourceSelected(state, payload) {
    state.sourceSelect = payload;
  },
  setSelectedCandidate(state, payload) {
    state.selectedCandidate = payload;
  },
  setSelectedProcess(state, payload) {
    state.selectedProcess = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
